import { createAction, handleActions } from 'redux-actions';
import { getFirstError } from '@adjust/dashboard-core/lib/errorMessage/errorMessage';

const initialState = {
  isResettingToken: false,
  isAlertOpen: false,
  trace: {
    status: 'info',
    message: '',
  },
};

// Actions

export const API_TOKEN_RESET_STARTED = 'userDetails/apiToken/API_TOKEN_RESET_STARTED';
export const API_TOKEN_RESET_SUCCEEDED = 'userDetails/apiToken/API_TOKEN_RESET_SUCCEEDED';
export const API_TOKEN_RESET_FAILED = 'userDetails/apiToken/API_TOKEN_RESET_FAILED';
export const ALERT_CLOSE = 'userDetails/apiToken/ALERT_CLOSE';

// Action creators

export const resetApiToken = createAction(API_TOKEN_RESET_STARTED);
export const resetApiTokenFailed = createAction(API_TOKEN_RESET_FAILED);
export const resetApiTokenSucceeded = createAction(API_TOKEN_RESET_SUCCEEDED);
export const closeAlert = createAction(ALERT_CLOSE);

// Reducer

const handleResetStarted = state => ({
  ...state,
  isResettingToken: true,
});

const handleResetFailed = (state, { payload }) => ({
  ...state,
  isResettingToken: false,
  isAlertOpen: true,
  trace: {
    status: 'error',
    message: getFirstError(payload.password, {
      invalid: t('error.invalid_password'),
    }),
  },
});

const handleResetSucceeded = state => ({
  ...state,
  isResettingToken: false,
  isAlertOpen: true,
  trace: {
    status: 'info',
    message: t('users.reset-api-token.success'),
  },
});

const handleAlertClose = state => ({
  ...state,
  isAlertOpen: false,
});

export default handleActions(
  {
    [API_TOKEN_RESET_STARTED]: handleResetStarted,
    [API_TOKEN_RESET_FAILED]: handleResetFailed,
    [API_TOKEN_RESET_SUCCEEDED]: handleResetSucceeded,
    [ALERT_CLOSE]: handleAlertClose,
  },
  initialState,
);
